// Regex 101 playground: https://regex101.com/r/KonG2z/1
const vimeoRegex = /^(?:(?<protocol>https?):)?\/\/(?:(?<subdomain>[\w-]+)\.)?(?<domain>(?:vimeo\.com|player\.vimeo\.com))\/(?<path>channels\/(?:\w+\/)?|groups\/videos\/|video\/)?(?<video_id>\d+)(?<suffix>\S+)?$/;

// Regex 101 playground https://regex101.com/r/prYRpe/2
const youtubeRegex = /^(?:(?<protocol>https?):?\/\/)?(?<subdomain>(?:www|m))?\.?(?<domain>(?:youtube(?:-nocookie)?\.com|youtu.be))\/(?<path>(?:[\w-]+\?v=|embed\/|v\/)?)(?<video_id>[\w-]+)(?<suffix>\S+)?$/;
const parsedVideoUrlProperties = ['protocol', 'subdomain', 'domain', 'path', 'video_id', 'suffix'];
// Type guard function returning a type predicate. Checks if passed object contains all the keys of a VideoUrlParseObject.
const isUrlParseObject = o => typeof o === 'object' && o !== null && parsedVideoUrlProperties.every(property => Object.hasOwn(o, property));

/**
 * Takes a string and parses the string into a VideoUrlParseObject, or null if the  string
 * is not a valid or supported YouTube or Vimeo video url.
 */
export const parseVideoUrl = s => {
  const youtubeUrlParseObject = s.match(youtubeRegex)?.groups;
  if (isUrlParseObject(youtubeUrlParseObject)) {
    // Return null if domain is youtube.com and path doesn't match the allowed paths for that domain
    if (youtubeUrlParseObject.domain === 'youtube.com' && youtubeUrlParseObject.path !== 'watch?v=' && youtubeUrlParseObject.path !== 'embed/') {
      return null;
    }
    return youtubeUrlParseObject;
  }
  const vimeoUrlParseObject = s.match(vimeoRegex)?.groups;
  if (isUrlParseObject(vimeoUrlParseObject)) return vimeoUrlParseObject;
  return null;
};